import React, {Component} from 'react';

import PictoLayer from './PictosLayer';
import {PICTO} from './ContribsMap'

class MenuLayer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listPicto: [],
      counter: 0
    };
  }

  hideShowLayerMenu = () => {
    var x = document.getElementById("btn-group-vertical");
    if (x.style.display === "") {
      x.style.display = "inline-flex";
    } else {
      x.style.display = "";
    }
  }

  updateCount = (checked, picto_id) => {
    if (checked === true){
      this.setState({counter: this.state.counter + 1});
      this.props.activateCallBack(picto_id);
    }
    else {
      this.setState({counter: this.state.counter - 1});
      this.props.disableCallBack(picto_id);
    }
  }

  componentDidMount() {
    const listPicto =   Object.entries(PICTO).map(([picto, index]) => {
        return (<PictoLayer id={this.props.layerNames[picto]["layerId"]} picto={PICTO[picto]["picto"]} title={PICTO[picto]["title"]} parentCallback={this.updateCount}/>);
    })
    this.setState({counter: listPicto.length, listPicto: listPicto});
  }

  render() {
    return (
      <div id="map-overlay">
          <div id="notification-buttons-container" title="Filtrer les témoignages par type d'impact">
            <button class="button layer-menu is-medium has-text-white" onClick={this.hideShowLayerMenu}>
              <span class="icon">
                <i class="fas fa-filter"></i>
              </span>
            </button>
            <span class="notification-count">{this.state.counter}</span>
          </div>
         <div id="btn-group-vertical">
            {this.state.listPicto}
         </div>

      </div>
    );
  }
}

export default MenuLayer;